import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { clearErrorMsg } from "./update";
import {
  ErrorMessageWrapper,
  Emoji,
  ErrorMessageText,
  CloseErrorButton,
} from "./styles/error-message-styles";

library.add(faTimes);

const ErrorMessage = ({ dispatch, showError }) => {
  const onCloseModal = () => {
    dispatch(clearErrorMsg);
  };

  return (
    <ErrorMessageWrapper showError={showError} data-test-id="error-message">
      <Emoji>
        <span role="img" aria-label="error-emoji">
          ⚠️
        </span>
      </Emoji>
      <ErrorMessageText>
        Sorry there has been a network error, please refresh the board.
      </ErrorMessageText>
      <CloseErrorButton
        onClick={onCloseModal}
        onKeyPress={onCloseModal}
        role="button"
        tabIndex="0"
      >
        <FontAwesomeIcon icon="times" />
      </CloseErrorButton>
    </ErrorMessageWrapper>
  );
};

ErrorMessage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired,
};

export default React.memo(ErrorMessage);
